import { IngestSubfolder } from '../../../../domain/src/lib/ingest/ingest-project.model';

/** Valor interno del select para raíz (mat-select no maneja bien `''`). */
export const INGEST_SUBFOLDER_ROOT_SELECT = '__ingest_root__';

export function resolveIngestSubfolderSelectValue(
  path: string | null | undefined,
): string {
  const normalized = String(path ?? '').trim();
  return normalized === '' ? INGEST_SUBFOLDER_ROOT_SELECT : normalized;
}

export function ingestSubfolderPathFromSelectValue(
  value: string | null | undefined,
): string {
  const normalized = String(value ?? '').trim();
  return normalized === INGEST_SUBFOLDER_ROOT_SELECT ? '' : normalized;
}

export function normalizeIngestSubfolder(raw: unknown): IngestSubfolder {
  if (!raw || typeof raw !== 'object') {
    return { path: '', display_name: '(Raíz)' };
  }
  const o = raw as Record<string, unknown>;
  const path = String(
    o['path'] ?? o['subfolder_path'] ?? o['folder_path'] ?? o['name'] ?? '',
  ).trim();
  const displayName = String(
    o['display_name'] ?? o['displayName'] ?? o['label'] ?? path ?? '(Raíz)',
  ).trim();
  return {
    path,
    display_name: displayName || path || '(Raíz)',
  };
}

export function normalizeIngestSubfolders(items: unknown[]): IngestSubfolder[] {
  if (!Array.isArray(items)) {
    return [];
  }
  return items.map(normalizeIngestSubfolder);
}

/** Etiqueta legible para listados y selects. */
export function formatIngestSubfolderDisplay(item: IngestSubfolder): string {
  const path = item.path?.trim();
  const display = item.display_name?.trim();
  if (!path) {
    return display || '(Raíz)';
  }
  if (display && display !== '(Raíz)' && !display.includes(' → ')) {
    return display;
  }
  return path;
}

/**
 * Conserva nombres devueltos por POST si el GET aún no refleja el nombre completo.
 */
export function mergeIngestSubfolderLists(
  fromServer: IngestSubfolder[],
  created?: IngestSubfolder | null,
): IngestSubfolder[] {
  if (!created?.path?.trim()) {
    return fromServer;
  }
  const createdRow = normalizeIngestSubfolder(created);
  const byPath = new Map(fromServer.map((row) => [row.path, row]));
  byPath.set(createdRow.path, createdRow);
  return Array.from(byPath.values()).sort((a, b) => a.path.localeCompare(b.path));
}

const INGEST_SUBFOLDER_NAME_PATTERN = /^[\p{L}\p{N}_-]+$/u;

const INGEST_SUBFOLDER_SLASH_MESSAGE =
  'El carácter "/" no está permitido en el nombre de la subcarpeta. Use guiones (-) o guiones bajos (_). Ejemplo: caja_dos o nuevo-prueba.';

const INGEST_SUBFOLDER_INVALID_CHARS_MESSAGE =
  'El nombre solo puede contener letras, números, guiones (-) y guiones bajos (_). Ejemplo: caja_dos o nuevo-prueba.';

/** Convierte espacios en guion bajo al escribir (el API no admite espacios en el segmento). */
export function normalizeIngestSubfolderNameInput(value: string | null | undefined): string {
  return String(value ?? '').replace(/\s+/g, '_');
}

/**
 * Valida el nombre de subcarpeta. El "/" no está permitido hasta que backend soporte nombres literales con ese carácter.
 */
export function validateIngestSubfolderName(name: string | null | undefined): string | null {
  const trimmed = normalizeIngestSubfolderNameInput(name).trim();
  if (!trimmed) {
    return 'El nombre de la subcarpeta es obligatorio.';
  }
  if (trimmed.includes('..')) {
    return 'El nombre no puede contener "..".';
  }
  if (trimmed.includes('/')) {
    return INGEST_SUBFOLDER_SLASH_MESSAGE;
  }
  if (trimmed.includes('\\')) {
    return 'El nombre no puede contener "\\".';
  }
  if (!INGEST_SUBFOLDER_NAME_PATTERN.test(trimmed)) {
    return INGEST_SUBFOLDER_INVALID_CHARS_MESSAGE;
  }

  return null;
}
